import { keyBy, merge } from 'lodash'
import { POST } from '@/api'

const COURSE = {
  id: null,
  name: null,
  image: null,
  description: null,
  price: {
    fixed: null,
    fixedTaxIn: null,
    discounted: null,
    discountedTaxIn: null,
  },
  kind: null,
  persons: {
    min: null,
    max: null,
  },
  menu: {
    count: null,
    text: null,
    notes: [],
  },
  drinkMenu: {
    count: {
      num: null,
      prefix: 0,
      suffix: 0,
    },
    items: [],
    notes: [],
  },
  notes: [],
}

/**
 * ぐるなびコース
 */
export default {
  namespaced: true,
  state: {
    byId: {},
    allIds: [],
    busy: false,
    next: 0,
    limit: 5,
  },
  mutations: {
    add(state, { courses = [], next }) {
      state.byId = { ...state.byId, ...keyBy(courses.map(course => merge({}, COURSE, course)), 'id') }
      state.allIds = state.allIds.concat(courses.map(({ id }) => id))
      state.next = next
    },
    update(state, course) {
      state.byId[course.id] = merge({}, COURSE, course)
    },
    clear(state) {
      state.byId = {}
      state.allIds = []
      state.next = 0
    },
    busy(state, busy = false) {
      state.busy = busy
    },
  },
  getters: {
    all({ byId, allIds }) {
      return allIds.map(id => byId[id])
    },
  },
  actions: {
    async get({ commit, state, rootState }, id) {
      if (state.busy || state.next === null) return
      commit('busy', true)

      const { status, message, data } = await POST(
        `/${rootState.reception.segment}/api/web/reception/gnavi_course/search`,
        id ? { id } : { start: state.next, limit: state.limit },
      )
      if (status === 200) {
        id ? commit('update', data.course[0]) : commit('add', { courses: data.course, next: data.pagenation.next })
      } else {
        commit('error/message', message, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
